import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AiChatwootBuddyComponent } from './ai-chatwoot-buddy.component';

const routes: Routes = [
  { path: '', component: AiChatwootBuddyComponent }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AiChatwootBuddyRoutingModule {}
